import { ReactNode } from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";

// ----------------------------------------------------------------------

interface EmptyStateProps {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: ReactNode;
}

/** Estado vazio padrão (busca sem resultado, listas vazias) */
export default function EmptyState({ title, description, actionLabel, onAction, icon }: EmptyStateProps) {
  const theme = useTheme();

  return (
    <Box sx={{ py: 6, textAlign: "center" }}>
      {icon && <Box sx={{ mb: 1.5, color: "text.disabled", "& svg": { fontSize: 40 } }}>{icon}</Box>}
      <Typography sx={{ fontFamily: theme.typography.fontFamilyDisplay, fontSize: 19, color: "text.primary" }}>
        {title}
      </Typography>
      {description && (
        <Typography sx={{ mt: 0.5, fontSize: "13px", color: "text.secondary" }}>{description}</Typography>
      )}
      {actionLabel && onAction && (
        <Button onClick={onAction} sx={{ mt: 2 }} variant="outlined" color="primary">
          {actionLabel}
        </Button>
      )}
    </Box>
  );
}
